<template>
  <div class="index">
    <div style="background: white">
      <div
        style="
          text-align: left;
          font-weight: bold;
          font-size: 16px;
          color: black;
          padding: 10px;
        "
      >
        成套设备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="color: #9D9D9D;font-size: 14px">*以下统计仅统计近3个月的订单</span>
      </div>
      <div class="data">
        <div class="item">
          <div class="value">{{ info.a2 }}</div>
          <div class="key">
            待确认订单
            <router-link
              :to="{ path: '/factoryUser/orderEqu', query: { index: 1 } }"
              >（查看）</router-link
            >
          </div>
        </div>
        <div class="item">
          <div class="value">{{ info.a3 }}</div>
          <div class="key">
            待签约
            <router-link
              :to="{ path: '/factoryUser/orderEqu', query: { index: 2 } }"
              >（查看）</router-link
            >
          </div>
        </div>
        <div class="item">
          <div class="value">{{ info.a4 }}</div>
          <div class="key">
            执行中订单
            <router-link
              :to="{ path: '/factoryUser/orderEqu', query: { index: 0 } }"
              >（查看）</router-link
            >
          </div>
        </div>
        <div class="item">
          <div class="value">{{ info.a5 }}</div>
          <div class="key">
            已完成订单
            <router-link
              :to="{ path: '/factoryUser/orderEqu', query: { index: 8 } }"
              >（查看）</router-link
            >
          </div>
        </div>
      </div>
    </div>
    <div style="background: white; margin: 20px 0">
      <div
        style="
          text-align: left;
          font-weight: bold;
          font-size: 16px;
          color: black;
          padding: 10px;
        "
      >
        应急保电
      </div>
      <div class="data">
        <div class="item">
          <div class="value">{{ info.b2 }}</div>
          <div class="key">
            待确认订单
            <router-link
              :to="{ path: '/factoryUser/orderEme', query: { index: 1 } }"
              >（查看）</router-link
            >
          </div>
        </div>
        <div class="item">
          <div class="value">{{ info.b3 }}</div>
          <div class="key">
            待签约
            <router-link
              :to="{ path: '/factoryUser/orderEme', query: { index: 2 } }"
              >（查看）</router-link
            >
          </div>
        </div>
        <div class="item">
          <div class="value">{{ info.b4 }}</div>
          <div class="key">
            执行中订单
            <router-link
              :to="{ path: '/factoryUser/orderEme', query: { index: 0 } }"
              >（查看）</router-link
            >
          </div>
        </div>
        <div class="item">
          <div class="value">{{ info.b5 }}</div>
          <div class="key">
            已完成订单
            <router-link
              :to="{ path: '/factoryUser/orderEme', query: { index: 12 } }"
              >（查看）</router-link
            >
          </div>
        </div>
      </div>
    </div>
    <div class="chart">
      <div class="pie">
        <div class="title">
          <div class="name">
            <div class="padding"></div>
            执行情况
          </div>
        </div>
        <div class="chart-area" id="chart-area-1"></div>
      </div>
      <div class="line">
        <div class="title">
          <div class="name">
            <div class="padding"></div>
            近七日订单
          </div>
          <div class="filter">
            <!-- <el-date-picker
							v-model="timeScope"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							size="mini"
						></el-date-picker> -->
          </div>
        </div>
        <div class="chart-area" id="chart-area-2"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {
    factory_index_data,
    factory_circle_chart,
    factory_line_chart,
    staTopApi, staTopApi2, getButtonSizeApi,
} from "../../http/factory/add-eme.js";
export default {
  name: "index",
  data() {
    return {
        buttonSize1:[],
        buttonSize0:[],
      toBeConfirmed: 0,
      confirmed: 0,
      underway: 0,
      finish: 0,
      timeScope: ["", ""],
      info: [],
        pie:[],
    };
  },
  methods: {


    open2() {
      this.$notify({
        title: "提示",
        dangerouslyUseHTMLString: true,
        message: "<h3 style=color:red><b>您有新的订单!</b></h3>",
        duration: 0,
      });
    },
      getNotifyButton(){

          this.getButtonSize();
      },


      getButtonSize(){
          getButtonSizeApi({
              orderType:1,
              superType: -1,
          }).then(response=>{
              // console.log(response)
              this.buttonSize1=response;
              let that;
              that=this;
              this.$notify({
                  title: "应急保电待办",
                  dangerouslyUseHTMLString: true,
                  message: "<span>您的应急保电订单处于待确认状态的有<b style='color:  red'>"+this.buttonSize1.csyj2+"条</b></span><br>"+
                      "<span>处于待收款并发货状态的有<b style='color:  red'>"+this.buttonSize1.csyj4+"条</b></span><br>"+
                      "<span>处于待确认用电完成状态的有<b style='color:  red'>"+this.buttonSize1.csyj7+"条</b></span><br>"+
                      "<span>处于待结算的订单有<b style='color:  red'>"+this.buttonSize1.csyj28+"条</b></span><br>"+
                      "<span>处于待续费的订单有<b style='color:  red'>"+this.buttonSize1.csyj60+"条</b></span><br>"
                  ,
                  duration: 0,
                  onClick(){
                      that.$router.push({
                          path:"/factoryUser/orderEme",
                      });
                  }
              });
          })
          getButtonSizeApi({
              orderType:0,
              superType: -1,
          }).then(response=>{
              // console.log(response)
              this.buttonSize0=response;
              let that;
              that=this;
              this.$notify({
                  title: "成套设备待办",
                  dangerouslyUseHTMLString: true,
                  message:  "<span>您的成套设备订单处于待确认状态的有<b style='color:  red'>"+this.buttonSize0.csct1+"条</b></span><br>"+
                      "<span>处于待支付服务费状态的有<b style='color:  red'>"+this.buttonSize0.csct24+"条</b></span><br>"+
                      "<span>处于待安装验收状态的订单有<b style='color:  red'>"+this.buttonSize0.csct5+"条</b></span><br>"
                  ,
                  duration: 0,
                  onClick(){
                      that.$router.push({
                          path: "/factoryUser/orderEqu",

                      });
                  }
              });
          })
      },
    initCharts() {

      // factory_circle_chart().then((res) => {
      //   this.initPie(res);
      // });
      factory_line_chart().then((res) => {
        this.initLine(res);
      });
      staTopApi2({
          type:"pcshouye",
          startTime:new Date(new Date().setMonth(new Date().getMonth()-3)).getFullYear() +
              '-' +(new Date(new Date().setMonth(new Date().getMonth()-3)).getMonth()+1<10?
                  '0'+(new Date(new Date().setMonth(new Date().getMonth()-3)).getMonth()+1):
                  (new Date(new Date().setMonth(new Date().getMonth()-3)).getMonth()+1))+
              "-" + new Date(new Date().setMonth(new Date().getMonth()-3)).getDate(),
          endTime:new Date().getFullYear() + '-' +(new Date().getMonth()+1<10?'0'+(new Date().getMonth()+1):(new Date().getMonth()+1))+ "-" + new Date().getDate()
      }).then((res) => {
        this.toBeConfirmed = res.a2+res.b2;
        // if (this.toBeConfirmed > 0) {
        //   this.open2();
        // }
        this.info = res;
        this.pie=[{
            "name":"待确认",
            "value":res.a2+res.b2,
        },
            {
                "name":"待签约",
                "value":res.a3+res.b3,
            },
            {
                "name":"执行中",
                "value":res.a4+res.b4,
            },
        ]
          this.initPie(this.pie);
        // this.confirmed = res.yqr;
        // this.underway = res.jxz;
        // this.finish = res.ywc;
      });
    },
    initPie(data) {
      var chartDom = document.getElementById("chart-area-1");
      var myChart = this.$echarts.init(chartDom);
      var option;

      option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "5%",
          left: "center",
        },
        series: [
          {
            name: "执行情况",
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "24",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: data,
          },
        ],
      };

      option && myChart.setOption(option);
    },
    initLine(data) {
      var chartDom = document.getElementById("chart-area-2");
      var myChart = this.$echarts.init(chartDom);
      var option;
      let xAxis = new Array();
      let series = new Array();
      for (let i = 0; i < data.length; i++) {
        xAxis.push(data[i].clickDate);
        series.push(data[i].count);
      }

      option = {
        xAxis: {
          type: "category",
          data: xAxis,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: series,
            type: "line",
          },
        ],
      };

      option && myChart.setOption(option);
    },
  },
  created: function () {
      this.getNotifyButton()
    //生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
  },
  mounted: function () {
      this.$notify.closeAll()
    //模板编译/挂载之后
    this.initCharts();
  },
  beforeUpdate: function () {
    //组件更新之前
  },
  updated: function () {
    //组件更新之后
  },
  activated: function () {
    // for keep-alive，组件被激活时调用
  },
  deactivated: function () {
    // for keep-alive，组件被移除时调用
  },
  beforeDestory: function () {
    // 组件销毁调用
  },
  destoryed: function () {
    // 组件销毁后调用
  },
};
</script>

<style>
.el-notification.right {
  right: 16px;
  background-color: bisque;
}
</style>

<style lang="less" scoped="scoped">
.index {
  width: 100%;
}

.data {
  width: 100%;
  height: 150px;
  background: @vue-bg-color;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .item {
    width: 25%;
    border-right: 1px solid @vue-border-color;

    .value {
      width: 100%;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: @vue-font-size-base;
      font-weight: bold;
    }

    .key {
      width: 100%;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: @vue-font-size-sm - 2;
      color: @vue-text-color-grey;

      a {
        color: @vue-text-color-grey;
      }

      a:hover {
        color: @vue-text-color-active;
      }
    }
  }

  .item:last-child {
    border: none;
  }
}

.chart {
  width: 100%;
  margin-top: @vue-spacing-col-lg;
  display: flex;
  justify-content: space-between;

  .pie {
    width: 400px;
  }

  .line {
    width: calc(100% - 424px);
  }

  .pie,
  .line {
    height: 400px;
    background: @vue-bg-color;
    padding: 0px @vue-spacing-row-base;
    box-sizing: border-box;
  }

  .title {
    width: 100%;
    height: 50px;
    border-bottom: 1px solid @vue-border-color;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;

    .name {
      height: 100%;
      display: flex;
      align-items: center;
    }

    .padding {
      width: 4px;
      height: 16px;
      background: #ff5252;
      margin-right: @vue-spacing-row-sm;
    }
  }

  .chart-area {
    width: 100%;
    height: 350px;
  }
}
</style>
